import styled, {css} from "styled-components"
import {Label} from "@irati/ui/src/Typography"

interface Props {
  uppercase?: boolean,
  bgColor?: string,
  color?: string,
  display?: "inline" | "block" | "inline-block",
  padding?: string | number | (number | string)[],
  margin?: string | number | (number | string)[]
}

export const Container = styled(Label)<Props>`
  ${({color, bgColor, uppercase, padding, margin, theme}) => css`
    background-color: ${bgColor || theme.colors.greys.black};
    color: ${color || theme.colors.greys.white};
    ${uppercase && "text-transform: uppercase;"}
    padding: ${padding || `${theme.spacing.one} ${theme.spacing.oneAndHalf}`};
    margin: ${margin};
    border-radius: ${theme.border.radius.medium};
  `}
`

export const RightContainer = styled(Label)<Props>`
  ${({color, bgColor, uppercase, theme}) => css`
    background-color: ${bgColor || theme.colors.greys.black};
    color: ${color || theme.colors.greys.white};
    ${uppercase && "text-transform: uppercase;"}
    padding: ${theme.spacing.one} ${theme.spacing.oneAndHalf};
    border-radius: 22px 0 0 22px;
    position: absolute;
    right: 0;
  `}
`
